import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ScriptHeader = ({ 
  playTitle, 
  currentAct, 
  currentScene, 
  onBackToDashboard,
  onToggleGlossary,
  isGlossaryOpen,
  linesRead = 0,
  totalLines = 0
}) => {
  const progressPct = totalLines > 0 ? Math.round((linesRead / totalLines) * 100) : 0;

  return (
    <div className="bg-card border-b border-border px-6 py-4">
      <div className="max-w-screen-2xl mx-auto">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="sm"
              iconName="ArrowLeft"
              iconPosition="left"
              onClick={onBackToDashboard}
            >
              Back to Stage
            </Button>
            <div className="h-6 w-px bg-border" />
            <div>
              <h1 className="text-xl font-semibold text-foreground">{playTitle}</h1>
              <p className="text-sm text-muted-foreground">
                Act {currentAct}, Scene {currentScene}
              </p>
            </div>
          </div>
          
          <div className="flex items-center gap-3 flex-wrap">
            {totalLines > 0 && (
              <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-primary/10 border border-primary/20">
                <Icon name="BookOpen" size={14} className="text-primary flex-shrink-0" />
                <span className="text-sm font-medium text-primary whitespace-nowrap">
                  {linesRead} of {totalLines} lines read
                </span>
                <span className="text-xs font-semibold text-primary/70 whitespace-nowrap">
                  ({progressPct}%)
                </span>
              </div>
            )}
            <Button
              variant="outline"
              size="sm"
              iconName="BookOpen"
              iconPosition="left"
              onClick={onToggleGlossary}
            >
              {isGlossaryOpen ? 'Hide' : 'Show'} Glossary
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScriptHeader;